import { Navigate } from "react-router-dom";
import Pricing from "../components/common/pricing";
import AddCustomerLogo from "../components/private/administration/addCustomerLogo";
import AddData from "../components/private/addData";
import AdminFeatures from "../components/private/administration/adminFeatures";
import ChangePassword from "../components/private/changePassword";
import Chat from "../components/private/chat";
import ContactSales from "../components/private/contactSales";
import Feedback from "../components/private/feedback";
import IngestData from "../components/private/ingestData";
import ManageSubAccounts from "../components/private/serviceProvider/manageSubAccounts";
import MaturityDomains from "../components/private/maturityAssessment/maturityDomains";
import MaturityAreas from "../components/private/maturityAssessment/maturityFlows";
import MaturityAssessmentBody from "../components/private/maturityAssessment/maturityFrameworks";
import MaturityQuestionnaire from "../components/private/maturityAssessment/maturityQuestionnaire";
import ScheduleConsultant from "../components/private/scheduleConsultant";
import UploadFiles from "../components/private/uploadFiles";
import UserManagement from "../components/private/administration/userManagement";
import UserReporting from "../components/private/administration/userReporting";
import ViewFormData from "../components/private/administration/viewFormData";
import Register from "../components/public/register";
import { useCases } from "../utils/constants";
import RegisterCustomers from "../components/private/serviceProvider/registerCustomers";
import TermsAndConditions from "../components/public/termsAndConditions";
import PrivacyPolicy from "../components/public/privacyPolicy";
import Login from "../components/public/login";
import VerifyLogin from "../components/public/verifyMFA";

const privateRoutes = [
	{ path: "/", element: <Navigate to="/chat" /> },
	{ path: "/login", element: <Login /> },
	{ path: "/chat", element: <Chat /> },
	{ path: "/verify-login", element: <VerifyLogin /> },
	{
		path: useCases[0].route,
		element: <Chat useCase={useCases[0].value} />,
	},
	{
		path: useCases[1].route,
		element: <Chat useCase={useCases[1].value} />,
	},
	{
		path: useCases[2].route,
		element: <Chat useCase={useCases[2].value} />,
	},
	{
		path: useCases[3].route,
		element: <MaturityAssessmentBody />,
	},
	{
		path: `/maturityAssessment/:frameworkId/areas`,
		element: <MaturityDomains />,
	},
	{
		path: `/maturityAssessment/:frameworkId/areas/:domainId/questionflow`,
		element: <MaturityAreas />,
	},
	{
		path: `/maturityAssessment/:frameworkId/areas/:domainId/questionflow/:questionFlowId/questionnaire`,
		element: <MaturityQuestionnaire />,
	},
	{
		path: `/ransomware/:frameworkId`,
		element: <MaturityDomains />,
	},
	{
		path: "/addData",
		element: <AddData />,
	},
	{
		path: "/viewFormData",
		element: <ViewFormData />,
	},
	{
		path: "/adminFeatures",
		element: <AdminFeatures />,
	},
	{
		path: "/adminFeatures/reporting/users",
		element: <UserReporting />,
	},
	{
		path: "/adminFeatures/management/users",
		element: <UserManagement />,
	},
	{
		path: "/schedule-consultant",
		element: <ScheduleConsultant />,
	},
	{
		path: "/addCustomerLogo",
		element: <AddCustomerLogo />,
	},
	{
		path: "/manageCustomers",
		element: <ManageSubAccounts />,
	},
	{ path: "/registerUsers", element: <Register /> },
	{ path: "/registerCustomers", element: <RegisterCustomers /> },
	{ path: "/feedback", element: <Feedback /> },
	{ path: "/pricing", element: <Pricing /> },
	{ path: "/changeAccountPassword", element: <ChangePassword /> },
	{ path: "/uploadFiles", element: <UploadFiles /> },
	{ path: "/ingest", element: <IngestData /> },
	{ path: "/contactSales", element: <ContactSales /> },
	{ path: "/terms-and-conditions", element: <TermsAndConditions /> },
	{ path: "/privacy-policy", element: <PrivacyPolicy /> },
];

export default privateRoutes;
